import useQueryString from "utils/customHooks/useQueryString";
import {
  useInterval,
  useIsSingleProcessPage,
  useProcessesInVisibleGroups,
} from "utils/customHooks/genericHooks";
import { DEFAULT_PAGE_ROTATION_INTERVAL } from "constants/intervals";
import { useLocation, useNavigate } from "react-router";
import qs from "query-string";
import { ONE_MINUTE_OF_MS } from "utils/timeUtils";
import { useFlightConfig } from "./DataGetter/FlightConfig/useFlightConfig";

export const ROTATE_GROUP = "rotategroup";

/** use query param ?rotate=true or ?rotate=3min to auto-rotate pages
 *
 * if page urls are specified in PAGES_TO_ROTATE, they will be rotated
 *
 * otherwise, we'll rotate through all processes in the group
 */
const AutoRotatePages = () => {
  const isSingleProcessPage = useIsSingleProcessPage();
  const parsedQuery = useQueryString();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const pagesInProcessGroup = usePathnamesFromVisibleProcesses();
  const stringifiedQuery = qs.stringify(parsedQuery);

  const pagesToRotate = pagesInProcessGroup;

  const pageIdx = pagesToRotate?.indexOf(pathname);

  const shouldRotate =
    isSingleProcessPage &&
    ("rotate" in parsedQuery || ROTATE_GROUP in parsedQuery) &&
    pageIdx !== -1;

  const minutesFromQuery =
    parsedQuery.rotate?.slice(-3) === "min" &&
    Number(parsedQuery.rotate?.slice(0, -3));
  const rotateDelay =
    minutesFromQuery && !isNaN(minutesFromQuery)
      ? minutesFromQuery * ONE_MINUTE_OF_MS
      : DEFAULT_PAGE_ROTATION_INTERVAL;

  const nextPagePath = pagesToRotate
    ? pagesToRotate[(pageIdx + 1) % pagesToRotate.length]
    : null;
  const [
    {
      hubletView: { autoRotateBetweenProcesses },
    },
  ] = useFlightConfig();

  useInterval({
    callback: () => {
      if (autoRotateBetweenProcesses && nextPagePath) {
        // ? if we want to sidestep memory leaks for now, this could do a full `window.location.href = ` instead of `navigate("mypath")`
        navigate(
          `${nextPagePath}${stringifiedQuery ? "?" + stringifiedQuery : null}`
        );
      }
    },
    immediate: false,
    delay: shouldRotate ? rotateDelay : null,
  });
  return null;
};

export default AutoRotatePages;

/** returns array of e.g. "/pai/grid/All/0" for the current group */
function usePathnamesFromVisibleProcesses() {
  const { pathname } = useLocation();
  const processesInVisibleGroups = useProcessesInVisibleGroups();
  return processesInVisibleGroups.map((p, idx) =>
    [...pathname.split("/").slice(0, -1), idx].join("/")
  );
}
